import { useQuery } from '@tanstack/react-query';
import { impersonationService } from '../../services/impersonationService';
import { CurrentSessionResponse } from '../../types/Impersonation';

export const impersonationKeys = {
  all: ['impersonation'] as const,
  session: () => [...impersonationKeys.all, 'session'] as const,
};

const IMPERSONATION_SESSION_POLL_MS = 5 * 60 * 1000; // 5 minutes

export const useImpersonationSessionQuery = (enabled: boolean) => {
  return useQuery<CurrentSessionResponse>({
    queryKey: impersonationKeys.session(),
    queryFn: () => impersonationService.getCurrentSession(),
    refetchInterval: IMPERSONATION_SESSION_POLL_MS,
    enabled,
  });
};
